import { REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES } from "@apps/rewards/constants/rewardsBrandingTypes";

/**
 * Determines if the pop up widget launcher should be visible based on the visibility settings.
 *
 * @param {REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES} launcherVisibility - The visibility setting for the launcher.
 * @returns True if the launcher should be visible, false otherwise.
 */
export const isPopUpWidgetLauncherVisible = (
    launcherVisibility: REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES
): boolean => {
    const isDesktop = window.innerWidth >= 1024;

    const isVisible =
        launcherVisibility ===
        REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES.allDevices;
    const isVisibleOnDesktop =
        launcherVisibility ===
        REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES.desktopOnly;

    return isVisible || (isVisibleOnDesktop && isDesktop);
};
